var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menuu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7420",
    "data-name": "Rectangle 7420",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11067",
    "data-name": "Path 11067",
    d: "M9,12a1,1,0,1,1-1-1A1,1,0,0,1,9,12Z",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11068",
    "data-name": "Path 11068",
    d: "M13,12a1,1,0,1,1-1-1A1,1,0,0,1,13,12Z",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11069",
    "data-name": "Path 11069",
    d: "M17,12a1,1,0,1,1-1-1A1,1,0,0,1,17,12Z",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11070",
    "data-name": "Path 11070",
    d: "M22,12c0,4.714,0,7.071-1.465,8.535S16.714,22,12,22s-7.071,0-8.536-1.465S2,16.714,2,12,2,4.929,3.464,3.464,7.286,2,12,2s7.071,0,8.535,1.464c.974.974,1.3,2.342,1.409,4.536",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuu);
export default __webpack_public_path__ + "static/media/menuu.3afa692f30d353cfdfa5770dfb9faaa1.svg";
export { ForwardRef as ReactComponent };